import { render, staticRenderFns } from "./ButtonDropdownDefault.vue?vue&type=template&id=6ac5ba31&scoped=true"
import script from "./ButtonDropdownDefault.vue?vue&type=script&lang=js"
export * from "./ButtonDropdownDefault.vue?vue&type=script&lang=js"
import style0 from "./ButtonDropdownDefault.vue?vue&type=style&index=0&id=6ac5ba31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac5ba31",
  null
  
)

export default component.exports